import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-yes-no-popup',
  templateUrl: './yes-no-popup.component.html',
  styleUrls: ['./yes-no-popup.component.scss']
})
export class YesNoPopupComponent implements OnInit {

  @Input() messageHeader: string;
  @Input() popupText1: string;
  @Input() popupText2: string;

  constructor(public activeModal: NgbActiveModal) {

  }

  ngOnInit(): void {
  }

  yes(){
    this.activeModal.close(true);
  }

  no(){
    this.activeModal.close(false);
  }

}
